
import TextalignLeft from "../../../assets/filled/TextalignLeft.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TextalignLeftIcon({ className, dataTestid = "TextalignLeftIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TextalignLeft data-testid={dataTestid} className={classes} {...rest} />
  );
}
